import gql from 'graphql-tag';

/**
 * Mutation to complete an inspection instance.
 * Transitions an inspection instance from in-progress status to completed.
 * Returns event result with success status and new version.
 */
export const completeInspectionInstanceMutation = gql`
  mutation completeInspectionInstance(
    $instanceId: UUID!
    $channelId: UUID!
    $completedAt: DateTime!
    $notes: String
  ) {
    completeInspectionInstance(
      instanceId: $instanceId
      channelId: $channelId
      completedAt: $completedAt
      notes: $notes
    ) {
      success
      newVersion
    }
  }
`;
